document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.accordian-container-grid').forEach(function (container) {
    var titles = container.querySelectorAll('.faq-title');

    var first = titles[0];
    if (first) {
      first.classList.add('open');
      first.nextElementSibling.classList.add('open');
      first.closest('.faq-block').classList.add('active');
    }

    titles.forEach(function (title) {
      title.addEventListener('click', function () {
        var isOpen = title.classList.contains('open');

        titles.forEach(function (t) {
          t.classList.remove('open');
          t.nextElementSibling.classList.remove('open');
          t.closest('.faq-block').classList.remove('active');
        });

        if (!isOpen) {
          title.classList.add('open');
          title.nextElementSibling.classList.add('open');
          title.closest('.faq-block').classList.add('active');
        }
      });
    });
  });
});
